export default {

	async modal_link_ban (ban, name = '') {

		const [ ban_record ] = await Promise.all([
			Anvil.models.CompanyBan.fetch(ban)
		])

		ban_record.name = name

		await Anvil.modal('/company_ban/modal_link_ban', { ban_record })
	},

	async action_link_ban (ban_record) {

		if (ban_record.company_id == null) {
			// Delete the record
			await Anvil.models.CompanyBan.delete(ban_record.ban)
		} else {
			// Commit the record
			await ban_record.record.commit()
		}

		Anvil.page.modal.close()
		Anvil.page.refresh()
	}
}